import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaionewaycabs() {



  const cardData =
  {
    keyword: 'Pune to Mumbai One Way Cab',
    heading: 'Sai Trupti Cabs: Pune to Mumbai One Way Cab',
    headingDescription: 'Sai Trupti Cabs offers affordable and reliable Pune to Mumbai One Way Cab services, making intercity travel convenient, safe, and comfortable. Our fleet of AC Sedans, SUVs, and Premium cars is well-maintained, ensuring a smooth ride for individuals, families, and corporate travelers alike. With professional, background-verified chauffeurs and transparent one-way pricing, you pay only for your journey — no hidden charges or return fares. Whether you’re heading to Mumbai city, Navi Mumbai, or Mumbai Airport, Sai Trupti Cabs guarantees on-time pickup, courteous service, and complete comfort from start to finish. Enjoy a stress-free Pune to Mumbai one way trip with Sai Trupti Cabs — your trusted travel partner for seamless and budget-friendly long-distance rides.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Pune to Mumbai One Way Cab",
    "description": "Pune to Mumbai One Way Cab provides convenient and affordable one-way travel between Pune and Mumbai. Customers pay only for a single trip, making it a cost-effective and comfortable solution for intercity travelers."
  },
  {
    "name": "Pune to Mumbai Drop Taxi",
    "description": "Pune to Mumbai Drop Taxi offers reliable one-way drop services with professional drivers and clean vehicles. It’s ideal for travelers looking for safe, punctual, and economical transfers to Mumbai."
  },
  {
    "name": "Pune to Mumbai One Way Taxi Fare",
    "description": "Pune to Mumbai One Way Taxi Fare ensures transparent and budget-friendly pricing for one-way trips. Customers receive upfront fare estimates with no hidden charges, ensuring complete clarity and satisfaction."
  },
  {
    "name": "Pune to Mumbai One Way Car Rental",
    "description": "Pune to Mumbai One Way Car Rental offers flexible car hire options for one-way intercity travel. Choose from sedans, SUVs, or hatchbacks for a smooth and convenient journey with experienced chauffeurs."
  },
  {
    "name": "Pune to Mumbai One Way Innova",
    "description": "Pune to Mumbai One Way Innova provides spacious Toyota Innovas ideal for family and group travel. Enjoy a comfortable and safe one-way journey with ample luggage space and air-conditioned interiors."
  },
  {
    "name": "Pune to Mumbai One Way Ertiga",
    "description": "Pune to Mumbai One Way Ertiga features Maruti Ertiga vehicles that offer comfort, reliability, and affordability. Suitable for small groups, this service ensures a relaxed travel experience at a fair price."
  },
  {
    "name": "Pune to Mumbai One Way Sedan",
    "description": "Pune to Mumbai One Way Sedan provides mid-size sedans perfect for small families or business travelers. The service combines comfort, elegance, and affordability for seamless one-way transfers."
  },
  {
    "name": "Pune to Mumbai One Way Hatchback",
    "description": "Pune to Mumbai One Way Hatchback is an economical choice for solo travelers and couples. Compact yet comfortable, these vehicles are perfect for quick, budget-friendly one-way journeys."
  },
  {
    "name": "Pune to Mumbai One Way AC Cab",
    "description": "Pune to Mumbai One Way AC Cab ensures a cool and comfortable ride with air-conditioned vehicles. Ideal for Pune’s warm weather, this service provides a pleasant and relaxing travel experience."
  },
  {
    "name": "Pune to Mumbai One Way Luxury Cab",
    "description": "Pune to Mumbai One Way Luxury Cab offers a premium experience with high-end vehicles like BMW, Audi, and Mercedes. Perfect for executive or VIP travel, it ensures maximum comfort and style."
  },
  {
    "name": "Pune to Mumbai Outstation One Way Cab",
    "description": "Pune to Mumbai Outstation One Way Cab provides long-distance one-way travel options for business and leisure travelers. The service ensures safe and comfortable rides with skilled drivers and well-maintained vehicles."
  },
  {
    "name": "Affordable Pune to Mumbai Cab",
    "description": "Affordable Pune to Mumbai Cab delivers budget-friendly travel solutions without compromising on safety or quality. With competitive fares and reliable service, it’s a preferred choice for regular travelers."
  },
  {
    "name": "Pune to Mumbai One Way Taxi Booking",
    "description": "Pune to Mumbai One Way Taxi Booking allows quick and easy online reservations for one-way trips. Customers can choose vehicle types, confirm fares instantly, and enjoy a hassle-free booking experience."
  },
  {
    "name": "Pune to Mumbai One Way Cab near Me",
    "description": "Pune to Mumbai One Way Cab near Me ensures fast access to nearby cabs for immediate or scheduled one-way travel. It provides reliable service with professional drivers across Pune’s locations."
  },
  {
    "name": "Pune to Mumbai One Way Ride",
    "description": "Pune to Mumbai One Way Ride offers smooth and affordable single-trip travel for all kinds of travelers. With flexible timing, clean vehicles, and courteous drivers, it ensures a pleasant intercity ride."
  }
],
"tableData": [
  ["Pune to Mumbai One Way Cab", "Pune to Mumbai Drop Taxi"],
  ["Pune to Mumbai One Way Taxi Fare", "Pune to Mumbai One Way Car Rental"],
  ["Pune to Mumbai One Way Innova", "Pune to Mumbai One Way Ertiga"],
  ["Pune to Mumbai One Way Sedan", "Pune to Mumbai One Way Hatchback"],
  ["Pune to Mumbai One Way AC Cab", "Pune to Mumbai One Way Luxury Cab"],
  ["Pune to Mumbai Outstation One Way Cab", "Affordable Pune to Mumbai Cab"],
  ["Pune to Mumbai One Way Taxi Booking", "Pune to Mumbai One Way Cab near Me"],
  ["Pune to Mumbai One Way Ride", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai One Way Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable one-way cab services from Pune to Mumbai, ideal for hassle-free travel without worrying about return trips."
  },
  {
    "WhyChooseheading": "Variety of Cab Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars to match your group size, luggage, and travel preferences."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune–Mumbai route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Enjoy clear, competitive rates with no hidden charges, making your one-way trip cost-effective and stress-free."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "We provide convenient pickups and drop-offs across Pune and Mumbai, including airports, railway stations, and city locations."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "All our cabs are well-maintained, sanitized, and equipped for a relaxing journey over long distances."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to help with bookings, route planning, and travel assistance."
  },
  {
    "WhyChooseheading": "Quick and Easy Booking Process",
    "WhyChoosedescription": "Book your Pune to Mumbai one-way cab effortlessly via call, WhatsApp, or our website, with instant confirmation and prompt dispatch."
  }
]

















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Mumbai one way cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Mumbai one way cab services for individuals and groups.',
  },
  {
    question: 'How can I book a Pune to Mumbai one way cab with Sai Trupti Cabs?',
    answer: 'You can book your Pune to Mumbai one way cab easily through our website, mobile app, or by calling our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available for Pune to Mumbai one way travel?',
    answer: 'We offer hatchbacks, sedans, SUVs, and tempo travellers for one way trips from Pune to Mumbai, depending on your travel preference and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Mumbai one way trips?',
    answer: 'Yes, all our drivers are professional, experienced, and familiar with the Pune–Mumbai route, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I schedule a Pune to Mumbai one way cab in advance?',
    answer: 'Absolutely. You can pre-book your Pune to Mumbai one way cab with Sai Trupti Cabs for guaranteed availability and timely pickup.',
  },
  {
    question: 'Is the Pune to Mumbai one way cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Pune to Mumbai one way cab services, perfect for early morning or late-night travel.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Mumbai one way cab rides?',
    answer: 'All vehicles are sanitized before every ride, and our drivers follow strict safety and hygiene measures to ensure your well-being.',
  },
  {
    question: 'What payment options are available for Pune to Mumbai one way cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available during the Pune to Mumbai one way cab journey?',
    answer: 'Yes, our 24×7 customer support team is always available to assist you during your Pune to Mumbai one way cab trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Deshmukh',
    feedback: 'I booked a Pune to Mumbai one way cab with Sai Trupti Cabs, and the experience was amazing. The car was clean and the driver was polite.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Shinde',
    feedback: 'Sai Trupti Cabs provided an excellent Pune to Mumbai one way cab service. The trip was smooth, and the fare was reasonable.',
    rating: 5,
  },
];






















































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai One Way Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mumbai-one-way-cab.jpg",
  "description": "Book Pune to Mumbai One Way Cab with Sai Trupti Cabs for a safe, fast, and affordable drop service. Choose from AC Sedans, SUVs, and Luxury Cars for comfortable one-way travel. Enjoy 24/7 booking, professional drivers, and transparent fares for a hassle-free ride.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "16123"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mumbai-one-way-cab"
  }
};



  return (
    <div>
      
<Helmet>
  <title>Pune to Mumbai One Way Cab | Affordable & Reliable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai One Way Cab with Sai Trupti Cabs for a safe, fast, and affordable drop service. Choose from AC Sedans, SUVs, and Luxury Cars for comfortable one-way travel. Enjoy 24/7 booking, professional drivers, and transparent fares for a hassle-free ride." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai One Way Cab, Pune to Mumbai Drop Taxi, Pune to Mumbai One Way Taxi Fare, Pune to Mumbai One Way Car Rental, Pune to Mumbai One Way Innova, Pune to Mumbai One Way Ertiga, Pune to Mumbai One Way Sedan, Pune to Mumbai One Way Hatchback, Pune to Mumbai One Way AC Cab, Pune to Mumbai One Way Luxury Cab, Pune to Mumbai Outstation One Way Cab, Affordable Pune to Mumbai Cab, Pune to Mumbai One Way Taxi Booking, Pune to Mumbai One Way Cab near Me, Pune to Mumbai One Way Ride" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaionewaycabs;